import { useMemo } from "react";
import { isEmpty } from "lodash";
import ICharityEmailSetup from "../../../../../../types/ICharityEmailSetup";

export interface DomainStatus {
  hasNoDomain: boolean;
  hasUnverifiedDomain: boolean;
  hasVerifiedDomain: boolean;
  currentDomain: string | null;
}

export const useDomainStatus = (
  emailSetup: ICharityEmailSetup | null,
  emailSetupLoaded: boolean
): DomainStatus => {
  return useMemo(() => {
    const status: DomainStatus = {
      hasNoDomain: false,
      hasUnverifiedDomain: false,
      hasVerifiedDomain: false,
      currentDomain: null,
    };

    if (!emailSetupLoaded) {
      return status;
    }

    const domain = emailSetup?.sendingDomain?.domain;
    const isVerified = emailSetup?.sendingDomain?.verified || false;

    if (!emailSetup || isEmpty(emailSetup) || !domain) {
      status.hasNoDomain = true;
    } else if (domain && !isVerified) {
      status.hasUnverifiedDomain = true;
      status.currentDomain = domain;
    } else if (domain && isVerified) {
      status.hasVerifiedDomain = true;
      status.currentDomain = domain;
    }

    return status;
  }, [emailSetup, emailSetupLoaded]);
};